/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@environments/environment';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';

import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { GlobalState } from '@store/states/global.state';
import { GlobalFacade } from '@store/facades/global.facade';
import { NgxsActionsExecutingModule } from '@ngxs-labs/actions-executing';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { StoreStorageModule } from './store-storage.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoaderFactory } from '@shared/utils/factories';
import { DEFAULT_LANGUAGE } from '@shared/constants/global.constants';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { HttpErrorsInterceptor } from '@shared/interceptors/http-errors.interceptors';
import { RouterModule } from '@angular/router';
import { appRoutes } from '../../app.routes';

const MODULES: any[] = [
  BrowserModule,
  RouterModule.forRoot(appRoutes),
  BrowserAnimationsModule,
  HttpClientModule,
  NgxsModule.forRoot([GlobalState], {
    developmentMode: !environment.production
  }),
  NgxsActionsExecutingModule.forRoot(),
  NgxsFormPluginModule.forRoot(),
  StoreStorageModule,
  NgxsReduxDevtoolsPluginModule.forRoot(),
  TranslateModule.forRoot({
    defaultLanguage: DEFAULT_LANGUAGE.fullLanguageCode,
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  MatSnackBarModule,
  MatDialogModule
];

const PROVIDERS = [
  GlobalFacade,
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: { appearance: 'outline' }
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorsInterceptor,
    multi: true
  }
];
@NgModule({
  imports: [...MODULES],
  providers: PROVIDERS,
  exports: [...MODULES]
})
export class CoreModule {}
